import React from 'react';
import { useTranslation } from 'react-i18next';

import Card from 'components/Account/Common/Card/Card';
import DetailsProductsTableFooter from 'components/Account/MyOrder/OrderDetails/DetailsProducts/DetailsProductsTableFooter/DetailsProductsTableFooter';
import TrackingDetails from 'components/Account/MyOrder/OrderDetails/DetailsProducts/Traking/TrackingDetails';
import { hasTrackingLink } from 'components/Account/MyOrder/OrderDetails/DetailsProducts/Traking/trackingUtils';
import ReturnLink, {
  returnLinkByMethod,
} from 'components/Account/MyOrder/OrderDetails/DetailsProducts/ReturnLink';
import { DataDetailledOrder } from 'types/DetailsProducts';
import { formatPrice } from 'services/formatter';

import styles from './DetailsProductsDesktop.module.scss';

type Props = {
  order: DataDetailledOrder;
};

export default function DetailsProductsDesktop({ order }: Props): JSX.Element {
  const { t } = useTranslation('ordersPage');
  const {
    idOrder,
    date,
    paymentMethod,
    deliveryMethod,
    products,
    subTotalOrder,
    subTotalDiscount,
    FPORT,
    FSIMO,
    FCR,
    FDOUA,
    REM,
    MTT_TOTAL,
  } = order;

  const finalCosts = [
    subTotalDiscount,
    subTotalOrder,
    FPORT,
    FSIMO,
    FCR,
    FDOUA,
    REM,
    MTT_TOTAL,
    paymentMethod,
    deliveryMethod,
  ];

  const displayTableHeader = [
    t('LABEL_ORDER_ITEM'),
    t('LABEL_ORDER_PRICE'),
    t('LABEL_ORDER_QUANTITY'),
    t('LABEL_ORDER_DISCOUNT'),
    t('LABEL_ORDER_SUBTOTAL'),
    t('LABEL_ORDER_STATEARTICLE'),
  ];

  const methodHasTracking = hasTrackingLink(deliveryMethod || '');
  const methodHasReturnLink = !!(
    deliveryMethod && returnLinkByMethod[deliveryMethod]
  );

  if (methodHasReturnLink && idOrder) {
    displayTableHeader.push(t('LABEL_ORDER_EASYRETURN_TITLE'));
  }

  return (
    <Card classes={{ container: styles.card }}>
      <div className={styles.titleArea}>
        {t('LABEL_ORDER_NUMBER_ORDER')}
        {t('LABEL_ORDER_ID_AND_DATE', { value: idOrder, date })}
      </div>
      <table>
        <thead>
          <tr>
            {displayTableHeader.map(title => (
              <th key={title}>{title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {products.map(({ discount, idColis, ...product }) => (
            <tr key={product.refCatalog}>
              <td>{product.libelle}</td>
              <td>{formatPrice(product.productPrice)}</td>
              <td>{product.quantity}</td>
              <td>{parseFloat(discount) > 0 && formatPrice(`-${discount}`)}</td>
              <td>{formatPrice(product.subTotalProduct)}</td>
              <td>
                {product.status}
                {methodHasTracking && idColis && (
                  <TrackingDetails
                    deliveryMethod={deliveryMethod || ''}
                    trackingNumber={idColis}
                    classes={{
                      trackingLabel: styles.trackingLabel,
                      trackingLink: styles.trackingLink,
                    }}
                  />
                )}
              </td>
              {deliveryMethod && methodHasReturnLink && idOrder && (
                <td>
                  {t('LABEL_ORDER_EASYRETURN_LABEL')}
                  <br />
                  <ReturnLink
                    deliveryMethod={deliveryMethod}
                    orderId={idOrder}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
        <DetailsProductsTableFooter
          component={'tfoot'}
          finalCosts={finalCosts}
          nbColumns={displayTableHeader.length}
        />
      </table>
    </Card>
  );
}
